import { Link } from "wouter";
import { Badge } from "@/components/Card";
import type { Standard } from "@/data";

type TabKey = "datos" | "elementos" | "lms" | "reglas" | "publicacion";

const TABS: { key: TabKey; label: string; suffix: string }[] = [
  { key: "datos", label: "Datos generales", suffix: "" },
  { key: "elementos", label: "Elementos", suffix: "/elementos" },
  { key: "lms", label: "Ruta formativa", suffix: "/lms" },
  { key: "publicacion", label: "Publicación", suffix: "/publicar" },
];

export function StandardTabsHeader({
  standard,
  active,
  rightAction,
}: {
  standard: Standard;
  active: TabKey;
  rightAction?: React.ReactNode;
}) {
  const codigo = standard.codigo;
  const estado = standard.estado;
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 16, marginBottom: 6 }}>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
            <span style={{ background: "var(--cc-navy)", color: "white", padding: "4px 10px", borderRadius: 6, fontSize: 12, fontWeight: 700 }}>{codigo}</span>
            <Badge tone={estado === "publicado" ? "green" : estado === "en-revision" ? "amber" : "gray"}>
              {estado === "publicado" ? "Publicado" : estado === "en-revision" ? "En revisión" : "Borrador"}
            </Badge>
            <span style={{ fontSize: 12, color: "var(--cc-gray-500)" }}>Última actualización: {standard.ultimaActualizacion}</span>
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: "var(--cc-navy)", maxWidth: 760 }}>{standard.titulo}</h1>
        </div>
        {rightAction && (
          <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>{rightAction}</div>
        )}
      </div>

      <div style={{ fontSize: 13, color: "var(--cc-gray-500)", marginBottom: 18 }}>
        {standard.sector}
        {standard.comite ? ` · ${standard.comite}` : ""} · Vigencia {standard.vigencia}
      </div>

      <div style={{ display: "flex", gap: 0, borderBottom: "1px solid var(--cc-gray-200)", marginBottom: 18 }}>
        {TABS.map((t) => {
          const isActive = t.key === active;
          const href = `/admin/estandares/${codigo}${t.suffix}`;
          if (isActive) {
            return (
              <div key={t.key} style={tabStyle(true)} data-testid={`tab-${t.label}`}>{t.label}</div>
            );
          }
          return (
            <Link key={t.key} href={href} data-testid={`tab-${t.label}`} style={tabStyle(false)}>{t.label}</Link>
          );
        })}
      </div>
    </>
  );
}

function tabStyle(active: boolean): React.CSSProperties {
  return {
    padding: "10px 18px",
    fontSize: 13,
    fontWeight: active ? 600 : 500,
    color: active ? "var(--cc-navy)" : "var(--cc-gray-500)",
    borderBottom: active ? "2px solid var(--cc-teal)" : "2px solid transparent",
    cursor: "pointer",
    textDecoration: "none",
  };
}
